import { render } from "./ReviewEditorPanel.vue?vue&type=template&id=203d9c61&scoped=true&ts=true"
import script from "./ReviewEditorPanel.vue?vue&type=script&lang=ts"
export * from "./ReviewEditorPanel.vue?vue&type=script&lang=ts"

import "./ReviewEditorPanel.vue?vue&type=style&index=0&id=203d9c61&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203d9c61"]])

export default __exports__